import React from 'react';

export default function AboutPage() {
    return (
        <h1>PC MASTER RACE!</h1>
    )
}